export default __webpack_public_path__ + "5408310f164f2cb12e10a1a2227ee535.svg";